const descale = (scaledValue, followersMarks) => {
  const priceIndex = followersMarks.findIndex(
    (price) => price.scaledValue >= scaledValue
  )
  // console.log('price index')
  if (!priceIndex) {
    return 0
  }
  const price = followersMarks[priceIndex]
  if (price.scaledValue === scaledValue) {
    return price.value
  }
  if (priceIndex === 0) {
    return 0
  }
  const m =
    (price.scaledValue - followersMarks[priceIndex - 1].scaledValue) /
    (price.value - followersMarks[priceIndex - 1].value || 1)
  const dX = scaledValue - followersMarks[priceIndex - 1].scaledValue
  return dX / m + followersMarks[priceIndex - 1].value
}

const scale = (value, followersMarks) => {
  const priceIndex = followersMarks.findIndex((price) => price.value >= value)
  const price = followersMarks[priceIndex < 0 ? 0 : priceIndex]
  if (price.value === value) {
    return price.scaledValue
  }
  if (priceIndex === 0) {
    return followersMarks[0].scaledValue
  }
  const m =
    (price.scaledValue - followersMarks[priceIndex - 1].scaledValue) /
    (price.value - followersMarks[priceIndex - 1].value || 1)
  const dX = value - followersMarks[priceIndex - 1].value
  return m * dX + followersMarks[priceIndex - 1].scaledValue
}

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + 'K' // convert to K for number from > 1000 < 1 million
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M' // convert to M for number from > 1 million
  } else if (num < 900) {
    return num // if value < 1000, nothing to do
  }
}

const numDeformatter = (numString) => {
  let num = parseInt(
    numString
      .replace('€', '')
      .replace('K', '')
      .replace('M', '')
      .replace(' ', '')
  )
  if (numString.includes('K')) {
    num = num * 1000
  }
  if (numString.includes('M')) {
    num = num * 1000000
  }
  return num
}

export { scale, descale, numFormatter, numDeformatter }
